module.exports = __webpack_public_path__ + "img/bump(2).48c00af1.png";